var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router_box",style:(_vm.theme),attrs:{"id":"routerBox"}},[(_vm.showReleaseTicker)?_c('ReleaseTicker'):_vm._e(),_c('router-view',{key:_vm.routerViewKey}),_c('GlobalAssistant')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }